import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';
import UserOnboarding from '../UserOnboarding';
import { getFirstAdminUserByCompanyIdService } from '../../services/company.service';
import './companyDetailsPopup.css';
import '../modal/AddCompanyModal/topUpModal.css';

const CompanyOnboardingReviewModal = (props) => {
    const { open, onClose, company } = props;
    const [adminUser, setAdminUser] = useState(null);
    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [infoMsg, setInfoMsg] = useState('');

    useEffect(() => {
        if (!open || !company?.Id) {
            setAdminUser(null);
            setErrorMsg('');
            setInfoMsg('');
            return;
        }
        let cancelled = false;
        setLoading(true);
        setErrorMsg('');
        setInfoMsg('');
        getFirstAdminUserByCompanyIdService(company.Id)
            .then((res) => {
                if (cancelled) return;
                const body = res?.data || {};
                const innerStatus = body?.Status;
                const entity = body?.Entity || null;
                if (innerStatus === 403) {
                    setErrorMsg(body?.Message?.MsgText || 'Access Denied.');
                    setAdminUser(null);
                    return;
                }
                if (innerStatus === 404 || !entity) {
                    setErrorMsg('No admin user found for this company.');
                    setAdminUser(null);
                    return;
                }
                const onboardingId = entity?.onboardingId;
                if (!onboardingId) {
                    // Don't render UserOnboarding (which would trigger child fetches) — just inform the user.
                    setInfoMsg('No onboarding details exist for this user.');
                    setAdminUser(null);
                    return;
                }
                // UserOnboarding reads onboarding id from `data.Id` — map onboardingId into Id
                // while preserving the rest of the admin user payload for downstream display.
                setAdminUser({ ...entity, Id: onboardingId });
            })
            .catch((err) => {
                if (cancelled) return;
                const httpStatus = err?.response?.status;
                const innerStatus = err?.response?.data?.Status;
                if (httpStatus === 404 || innerStatus === 404) {
                    setErrorMsg('No admin user found for this company.');
                } else if (httpStatus === 403 || innerStatus === 403) {
                    setErrorMsg(err?.response?.data?.Message?.MsgText || 'Access Denied.');
                } else {
                    setErrorMsg('Unable to load onboarding details.');
                }
                setAdminUser(null);
            })
            .finally(() => {
                if (!cancelled) setLoading(false);
            });
        return () => { cancelled = true; };
    }, [open, company?.Id]);

    return (
        <Modal
            show={!!open}
            onHide={onClose}
            size="lg"
            centered
            backdrop="static"
            className="topUpModal companyOnboardingReviewPopup"
        >
            <div className="top_modal_header_container">
                <span>Onboarding Review{company?.name ? ` - ${company.name}` : ''}</span>
                <div className="modalDeleteWrapper">
                    <button
                        type="button"
                        onClick={onClose}
                        className="btn-close"
                        aria-label="Close"
                    ></button>
                </div>
            </div>
            <div className="modal_container_rate_card fontFix companyOnboardingReviewPopup-body">
                {loading && <div className="text-center py-4">Loading...</div>}
                {!loading && errorMsg && (
                    <div className="text-center py-4 text-danger">{errorMsg}</div>
                )}
                {!loading && !errorMsg && infoMsg && (
                    <div className="text-center py-4">{infoMsg}</div>
                )}
                {!loading && !errorMsg && !infoMsg && adminUser && (
                    <UserOnboarding
                        isViewUserRequest={true}
                        isApprovedSeller={!!adminUser?.isApproved}
                        data={adminUser}
                        close={onClose}
                        hideHeader={true}
                        isReadOnly={true}
                    />
                )}
            </div>
        </Modal>
    );
};

CompanyOnboardingReviewModal.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    company: PropTypes.object,
};

export default CompanyOnboardingReviewModal;

